import React from "react";
import {
  Layers,
  FolderOpenDot,
  Users,
  LibraryBig,
  Library,
  LayoutPanelTop,
  SquareDashed,
} from "lucide-react";
import { link } from "fs";

export const getStatsItemsList = (statsObj: any) => [
  {
    title: "Templates",
    icon: Layers,
    count: statsObj.templatesCount,
    link: "/templates",
  },
  {
    title: "Sets",
    icon: LayoutPanelTop,
    count: statsObj.setsCount,
    link: "/sets",
  },
  {
    title: "Print Locations",
    icon: SquareDashed,
    count: statsObj.printLocationsCount,
    link: "/print-locations",
  },
  {
    title: "Categories",
    icon: LibraryBig,
    count: statsObj.categoriesCount,
    link: "/categories",
  },
  {
    title: "Subcategories",
    icon: Library,
    count: statsObj.subcategoriesCount,
    link: "/subcategories",
  },
  {
    title: "Projects",
    icon: FolderOpenDot,
    count: statsObj.projectsCount,
    link: "/projects",
  },
  {
    title: "Users",
    icon: Users,
    count: statsObj.usersCount,
    link: "/users",
  },
];
